/**
 * This file was copied from the CAS Angular repository and may not be up to date.
 * Please check the source repository for the latest version.
 * Source: src\app\_services\authorization\token-manager.service.ts
 */

import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, filter, firstValueFrom, lastValueFrom, Observable, take } from 'rxjs';
import { AuthEndpoints, AuthResponse } from '@apis/cas';
import { environment } from '@environments/environment';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { decodeJwt } from 'jose';

@Injectable({
  providedIn: 'root',
})
export class TokenManagerService {
  private accessToken = new BehaviorSubject<string | undefined>(undefined);
  private tokenValidUntil?: number;
  private currentLoadRequest?: Observable<AuthResponse | Error>;

  private authApi = inject(AuthEndpoints);

  public clear() {
    this.tokenValidUntil = undefined;
    this.accessToken.next(undefined);
  }

  public stream(): Observable<string | undefined> {
    return this.accessToken.asObservable();
  }


  public set(token: string) {
    const decoded = decodeJwt(token);
    this.tokenValidUntil = decoded.exp ? decoded.exp * 1000 : undefined;
    this.accessToken.next(token);
  }

  public get(): Promise<string> {
    return new Promise((resolve, reject) => {
      // Check if the token is still valid for the next 30 seconds, if it is, return/use it
      if (this.accessToken.value !== undefined && (this.tokenValidUntil === undefined || this.tokenValidUntil > Date.now() + 30 * 1000)) {
        resolve(this.accessToken.value);
        return;
      }

      if (this.accessToken.value !== undefined) {
        // We reset the token to prevent reusing an expired token
        this.clear();
      }

      if (this.currentLoadRequest === undefined) {
        this.currentLoadRequest = this.loadNewToken();
        this.currentLoadRequest.subscribe((r) => {
          if (r instanceof Error) {
            reject(r);
          }
        });
      }

      firstValueFrom(this.accessToken.pipe(filter(Boolean), take(1))).then(resolve);
    });
  }

  private loadNewToken(): Observable<AuthResponse | Error> {
    return fromPromise(
      lastValueFrom(this.authApi.login(environment.casReadonlyUser.username, environment.casReadonlyUser.password))
        .then((data) => {
          this.currentLoadRequest = undefined;
          this.set(data.accessToken);
          return data;
        })
        .catch((e) => {
          this.currentLoadRequest = undefined;
          return new Error(e.message);
        }),
    );
  }
}
